// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';

import { MerchantInfo } from '../../../organisms/merchant-info';
import { MobileDisplayValues } from '../../../organisms/mobile-display-values';
import { Separator } from '../../../atoms';

import { HelpCenterInfo } from './help-center-info';
import { PaymentInstructions } from './payment-instructions';
import { PaymentLocationsInfo } from './payment-locations-info';
import { PrintVoucherButton } from './print-voucher-button';
import { SavePdfButton } from './save-pdf-button';
import { Ticket } from './ticket';

export function EfectyPage(): Node {
  const incomingPayment = useIncomingPayment();

  return (
    <Root>
      <MobileDisplayValues />
      <Body>
        <Title>Recibo Efecty generado!</Title>
        <PaymentWarningWrapperContent>
          Una copia de tu recibo fue enviada a
          <strong> {getCustomerEmail(incomingPayment)}</strong>,
          sin embargo, ya puedes pagar tu compra con los siguientes datos:
        </PaymentWarningWrapperContent>
        <Separator direction="vertical" size={4} />
        <Ticket />
        <Separator direction="vertical" size={4} />
        <PrintVoucherButton />
        <Separator direction="vertical" size={4} />
        <SavePdfButton />
        <SectionSeparator />
        <PaymentLocationsInfo />
        <SectionSeparator />
        <PaymentInstructions />
        <SectionSeparator />
        <HelpCenterInfo />
        <SectionSeparator />
        <MerchantInfo />
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 16px;
`;

const Title = styled.h1`
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;

const PaymentWarningWrapperContent = styled.p`
  padding-top: 7px;
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.sansSerif};
`;

function SectionSeparator(): Node {
  return (
    <>
      <Separator direction="vertical" size={4} />
      <Separator direction="vertical" size={4} pattern="dotted" />
      <Separator direction="vertical" size={4} />
    </>
  );
}
